<template>
  <router-view v-slot="{ Component }">
    <GlobalLoading />
      <component :is="Component" />
  </router-view>
</template>
<script setup>
import GlobalLoading from '@/components/loadingCom';
import {onMounted} from "vue";
import {useStore} from 'vuex'
const store = useStore()
onMounted(()=>{
  store.dispatch("sysModel/getAllsettingsFun") // 获取系统配置
})
// 解决el-table 报错
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _= window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _{
  constructor(callback) {
    callback = debounce(callback,20)
    super(callback);
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  //background: orangered;
  //width: 100vh;
  //min-width: 1000px;
  //min-width: 500px;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
